import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import classnames from 'classnames';
import noop from 'lodash/noop';
import { TIME_TRACKING_ROLES } from '../../constants';
import get from 'lodash/get';

const BarberHoverMenuTimeTrackingToggleButton = ({
  onTimeTrackClick,
  active,
  busyIsOn,
  extendedHourlyWages,
  barberRole,
}) => {
  const roleTitle = get(TIME_TRACKING_ROLES, [barberRole, 'label'], '');
  const clockOutText = extendedHourlyWages ? `Clock out (${roleTitle})` : 'Clock out';

  return (<Link
    onClick={busyIsOn ? noop : onTimeTrackClick}
    className={classnames(
      'u-inline-block c-btn c-btn--transparent',
      active ? 'u-font-color-red' : 'u-font-color-primary',
      { 'is-disabled': busyIsOn }
    )}
  >
    {active ? clockOutText : 'Clock in'}
  </Link>);
};

BarberHoverMenuTimeTrackingToggleButton.propTypes = {
  active: PropTypes.bool.isRequired,
  onTimeTrackClick: PropTypes.func.isRequired,
  busyIsOn: PropTypes.bool.isRequired,
  extendedHourlyWages: PropTypes.bool.isRequired,
  barberRole: PropTypes.string.isRequired,
};

export default BarberHoverMenuTimeTrackingToggleButton;
